



































































import {Component, Inject, Vue} from 'vue-property-decorator';
import {requestNodeHealthData} from '@api/widgetApi';
import {NodeHealthWidget} from '@v/dashboard/interfaces';
import WidgetBindDataSource from '@/components/widgets/base/WidgetBindDataSource.vue';
import Loading from '@c/controls/Loading.vue';

@Component({components: {WidgetBindDataSource, Loading}})
export default class NodeHealthWidgetComponent extends Vue {
  //Данные виджета
  @Inject()
  widget!: NodeHealthWidget;

  // Точность представления нецелых чисел
  protected viewRoundingAccuracy = 0;

  // Значение здоровья станка\узла
  health: number | null = null;
  healthUnit = '';

  // Нижняя граница здоровья станка\узла
  healthBoundary = 30;

  nodeId: string | null = null;

  // Наименование узла
  nodeName = '';

  // TODO когда в БД появятся краткие наименования заменить
  get nodeShortName() {
    return this.nodeName;
  }

  // Показатели загрузки и наличия ошибок
  loading = true;
  error = false;

  // Цвет заголовка
  colors = ['#e5e5e5', '#ffcc99'];

  get formattedValue() {
    if (this.health == null) return 'н/д';
    let val = this.health;
    if (this.health > 100000) val = this.health / 1000;
    return val.toFixed(this.viewRoundingAccuracy);
  }

  get formattedUnit() {
    const unit = this.healthUnit != '-' ? this.healthUnit : '';
    if (this.health && this.health > 10000) return `тыс. ${unit}`;
    return `${unit}`;
  }

  // Действия при выборе узла
  onNodeSelect(data: {nodeId: string; nodeName: string}) {
    this.widget.nodeId = data.nodeId;
    this.widget.nodeName = data.nodeName;
    this.nodeId = data.nodeId;
    this.nodeName = data.nodeName;
    this.attachNode(this.widget.nodeId);
  }

  created() {
    this.nodeId = this.widget.nodeId;
    this.nodeName = this.widget.nodeName;
    this.attachNode(this.widget.nodeId);
  }

  // Привязка узла
  async attachNode(nodeId: string | null) {
    if (!nodeId) return;
    await this.getData(nodeId);
  }

  async getData(nodeId: string) {
    this.nodeId = nodeId;
    try {
      const {health, healthUnit} = await requestNodeHealthData(nodeId);
      this.health = health;
      this.healthUnit = healthUnit;
    } catch {
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  get colorCaption() {
    const indexColor = this.health && this.health < this.healthBoundary ? 1 : 0;
    return this.colors[indexColor];
  }
}
